import React from "react"
export function Expressway(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M1.693 9.537l-.073.086a.654.654 0 00.535 1.03h4.577v7.193c0 .36.293.653.654.653h5.23l.118-.01a.654.654 0 00.536-.643v-7.192h4.577a.654.654 0 00.463-1.117l-7.846-7.845a.654.654 0 00-.925 0L1.693 9.537z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__expressway"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
